import React from "react";
import "./MainMenu.scss";
import * as headerActions from "../../actions/header";
import * as authActions from "../../actions/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, NavLink } from "react-router-dom";
import "./../../i18n";
import { useTranslation } from "react-i18next";
import axios from "axios";

import user from "../../images/home/user.png";
import userLogout from "../../images/home/logout.png";

import flagLt from "../../images/flags/LT.png";
import flagEn from "../../images/flags/GB.png";
import flagFin from "../../images/flags/FI.png";
import flagRu from "../../images/flags/RU.png";

const MainMenu = (props) => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.translator.language || "lt";

  const langs = ["lt", "en", "fin", "ru"];

  const flags = {
    lt: flagLt,
    en: flagEn,
    fin: flagFin,
    ru: flagRu,
  };

  const langLabels = {
    lt: "Lietuvių",
    en: "English",
    fin: "Suomi",
    ru: "Русский",
  };

  const closeMenu = () => {
    props.toggleMenu();
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);

    if (props.isAuth) {
      axios.put(`/api/user/lang/${language}`).catch((err) => {
        console.error(err);
      });
    }
  };

  const handleLangClickMobile = (lang, e) => {
    e.preventDefault();

    changeLanguage(lang);
    props.toggleLangsMobile(false);
  };

  const logoutHandler = () => {
    props.logout();
    window.location = "/logout";
  };

  return (
    <div className="main-menu">
      <div className="main-menu__overlay" onClick={closeMenu} />

      <div className="main-menu__card">
        <button
          type="button"
          className="main-menu__close"
          onClick={closeMenu}
          aria-label={t("common.closeMenu")}
        >
          ×
        </button>

        <nav className="main-menu__nav">
          <NavLink exact to="/" activeClassName="active" onClick={closeMenu}>
            {t("nav.home")}
          </NavLink>

          {!props.isAuth ? (
                          <NavLink to="/about" activeClassName="active" style={{ width: "124px" }}>
                            {t("nav.partner")}
                          </NavLink>
                        ) : null}

          <NavLink to="/contacts" activeClassName="active" onClick={closeMenu}>
            {t("nav.contacts")}
          </NavLink>

          {props.isAuth ? (
            <>
              <NavLink to="/shop" activeClassName="active" onClick={closeMenu}>
                {t("nav.shop")}
              </NavLink>

              <NavLink to="/orders" activeClassName="active" onClick={closeMenu}>
                {t("nav.orders")}
              </NavLink>

              <NavLink to="/balance" activeClassName="active" onClick={closeMenu}>
                {t("nav.balance")}
              </NavLink>
            </>
          ) : null}
        </nav>

        <a href="mailto:info@gudema.lt" className="main-menu__email">
          info@gudema.lt
        </a>

        {/* <div className="main-menu__lang">
          <button
            type="button"
            onClick={props.toggleLangsMobile.bind(
              this,
              !props.langsOpenMobile
            )}
          >
            <img src={flags[currentLanguage]} alt={currentLanguage} />
            {langLabels[currentLanguage]}
            <span className={props.langsOpenMobile ? "rotated" : ""}>›</span>
          </button>

          {props.langsOpenMobile ? (
            <ul>
              {langs.map((lang) => {
                if (lang === currentLanguage) return null;

                return (
                  <li key={lang}>
                    <a href="#" onClick={handleLangClickMobile.bind(this, lang)}>
                      <img src={flags[lang]} alt={lang} />
                      {langLabels[lang]}
                    </a>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div> */}

        <a
          href="https://shop.floraplaza.nl/floraplaza/en/EUR/login?store=34356"
          target="_blank"
          rel="noreferrer"
          className="main-menu__floraplaza"
        >
          Floraplaza
        </a>

        {props.isAuth ? (
          <button
            type="button"
            className="main-menu__login"
            onClick={logoutHandler}
          >
            <img src={userLogout} alt="" />
            {t("nav.logout")}
          </button>
        ) : (
          <Link to="/login" className="main-menu__login" onClick={closeMenu}>
            <img src={user} alt="" />
            {t("nav.login")}
          </Link>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formIsOpen: state.header.formIsOpen,
  cart: state.shop.cart,
  isAuth: !!state.auth.authUsername,
  username: state.auth.username,
  authUsername: state.auth.authUsername,
  langsOpen: state.header.langsOpen,
  langsOpenMobile: state.header.langsOpenMobile,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(headerActions, dispatch),
  ...bindActionCreators(authActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);